@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.quantity-select {
  position: relative;
  width: 80px;
  font-size: 24px;
  font-weight: @bold;

  .dropdown-menu {
    position: static;
  }

  &.single-value {
    text-align: center;
    border-radius: 4px;
    background: @quantity-select--single-value--background-color;
    line-height: 36px;
  }

  &.value-without-dropdown {
    .number-input {
      border-radius: 4px;
      border: 1px solid @quantity-select--value-without-dropdown--border-color;
      width: 100%;
    }
  }

  &.big-number {
    font-size: 20px;
  }
}

.number-input {
  display: inline-block;
  vertical-align: top;
  line-height: 34px;
  border: 1px solid @quantity-select--number-input--border-color;
  border-right: 0;
  padding: 0 10px;
  font-weight: @bold;
  border-radius: 4px 0 0 4px;
  width: calc(100% ~'-' 31px);
  height: auto;
}

.dropdown-menu {
  display: inline-block;
  vertical-align: top;

  .dropdown-menu-button {
    padding: 0;
    border-radius: 0 4px 4px 0;
    height: 36px;
  }
}

.dropdown-menu-item {
  font-size: 24px;
  font-weight: @bold;
}
